import { IEmbedConfigurationBase } from 'embed';
import moment from 'moment';
import * as fabric from 'office-ui-fabric-react';
import * as pbi from 'powerbi-client';
import React, { FC, useEffect, useState } from 'react';
import * as api from '../../api/generated';
import { ShowErrorModal } from '../queueManagement/components/ShowErrorModal';

export interface DataStateModel {
    id: string;
    embedUrl: string;
    embedToken: EmbedToken;
}

export interface EmbedToken {
    token: string;
    tokenId: string;
    expiration: moment.Moment;
}

const PowerBiStatistics: FC = () => {
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const show = async () => {
            try {
                const resp = await api.statistic.getPowerBiStatistics();

                let accessToken = resp!.embedToken!.token;
                let embedUrl = resp!.embedUrl;
                let embedReportId = resp!.id;

                let config: IEmbedConfigurationBase = {
                    type: 'report',
                    tokenType: pbi.models.TokenType.Embed,
                    accessToken: accessToken!,
                    embedUrl: embedUrl,
                    uniqueId: embedReportId
                };
                let reportContainer = document.getElementById('reportContainer')!;
                if (reportContainer) {
                    let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
                    powerbi.embed(reportContainer, config);
                }
            } catch (err) {
                setError(err.error);
            }
        };
        show();
    }, []);

    return (
        <>
            <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12">
                        <fabric.Text variant="xxLarge">Statistika</fabric.Text>
                    </div>

                    <div id="reportContainer" style={{ height: `${window.innerHeight - 180}px` }}></div>
                </div>
            </div>
            {error && <ShowErrorModal logout={true} error={error}></ShowErrorModal>}
        </>
    );
};

export default PowerBiStatistics;
